export default async ({ page: { languageCode } }) => {
  if (!Intl || !Intl.NumberFormat || !Intl.NumberFormat.prototype.formatToParts) {
    const { default: IntlPolyfill } = await import(/* webpackChunkName: "intl" */ 'intl');
    await import(
      /* webpackChunkName: "intl-locale-data" */ `intl/locale-data/jsonp/${languageCode}.js`
    );
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
  }
};
